// export const ComponentType = {
//     text: 'text',
//     button: 'button',
//     video: 'video',
//     image: 'image',
//     file: 'file',
//     marquee: 'marquee',
//     pdf: 'pdf',
//     clock: 'clock',
//     weather: 'weather'
// } as const;

import { Size } from "../app/@types/template"

// export type ComponentType = typeof ComponentType[keyof typeof ComponentType];
export const LandscapeSize: Size = {
  width: 950,
  height: 450
}

export const PortraitSize: Size = {
  width: 450,
  height: 950
}

export const GRID_SIZE = 1;
export const MAX_CANVAS_COMPONENTS = 200;

export const EnumComponentType = {
    Text: 'Text',
    Button: 'Button',
    Video: 'Video',
    Image: 'Image',
    File: 'File',
    Marquee: 'Marquee',
    Pdf: 'Pdf',
    Clock: 'Clock',
    Weather: 'Weather',
    Audio: 'Audio',
    RichText: 'RichText'
}
export const EnumContentType = {
  Image: 'Image',
  Video: 'Video',
  Text: 'Text',
  Html: 'Html'
};

// Media file extensions
export const MediaExtensions = {
  Video: ['mp4', 'mov', 'avi', 'wmv', 'flv', 'webm', 'mkv'],
  Audio: ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'flac'],
  Image: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'],
  Document: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv']
};

export const UserRole = {
  SuperAdmin: "SuperAdmin",
  Admin: "Admin",
  User: "User",
  Checker: "Checker",
  Maker: "Maker"
}

export const GetDefaultSize: (orientation: 'Portrait' | 'Landscape') => Size = (orientation) => {
  return orientation === 'Portrait' ? PortraitSize : LandscapeSize
}

